import CONSTANTS from '@/constants'
import api from './api'

const points = {
	datatable(params) {
		return api.post(`${CONSTANTS.API_BASE_URL}/api/points/datatable`, params)
	},
	export(params) {
		return api.post(`${CONSTANTS.API_BASE_URL}/api/points/export`, params)
	},
}

export default points
